var React = require('react');

function List (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"}));
}

List.defaultProps = {"width":"16","height":"16","fill":"currentColor","className":"bi bi-list","viewBox":"0 0 16 16"};

module.exports = List;

List.default = List;
